import React, { useState,useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Upload, Button, Progress, Typography, Space, Modal, Result } from 'antd';
import {
  CloudUploadOutlined,
  CheckCircleFilled,
  CloseOutlined,
  FileOutlined,
  EyeOutlined,
} from '@ant-design/icons';
import {
  ButtonAnt
} from '@pfmam/pfmam';
import { UploadFundDocument } from '../../actions/actions';
import { set } from 'react-ga';
const { Text, Title } = Typography;
const { Dragger } = Upload;

const CardWrapper = styled.div`
  display: flex;
  max-width: 900px;
  margin: 40px auto;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  min-height: 420px;
`;

const LeftPanel = styled.div`
  flex: 1;
  padding: 32px;
  display: flex;
  flex-direction: column;
`;

const RightPanel = styled.div`
  flex: 1;
  padding: 32px;
  background: #fafbff;
  display: flex;
  flex-direction: column;
  border-left: 1px solid #f0f0f0;
`;

const DropZone = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;

  .ant-upload-wrapper {
    width: 100%;
    height: 100%;
  }

  .ant-upload-drag {
    border: 2px dashed ${(props) => props.linkTextColor} !important;
    border-radius: 12px !important;
    background: #f8f8ff !important;
    padding: 40px 20px;
    transition: border-color 0.3s;

    &:hover {
      border-color: ${(props) => props.linkTextColor} !important;
    }
  }

  .ant-upload-drag-icon {
    .anticon {
      color: ${(props) => props.linkTextColor} !important;
      font-size: 48px;
    }
  }

  .ant-upload-text {
    color: #333;
    font-size: 16px;
    margin-top: 12px;
  }

  .ant-upload-hint {
    color: #999;
    font-size: 13px;
  }
`;

const FileList = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-top: 16px;
`;

const FileRow = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`;

const FileIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #ededff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;

  .anticon {
    color: ${(props) => props.linkTextColor} !important;
    font-size: 16px;
  }
`;

const FileInfo = styled.div`
  flex: 1;
  .file-name {
    font-size: 14px;
    color: #333;
    margin: 0;
    line-height: 20px;
  }
  .file-size {
    font-size: 12px;
    color: #999;
    margin: 0;
  }
`;

const FileAction = styled.div`
  margin-left: 12px;
  cursor: pointer;
  .anticon-check-circle {
    color: #52c41a;
    font-size: 18px;
  }
  .anticon-close {
    color: #999;
    font-size: 14px;
    &:hover {
      color: #ff4d4f;
    }
  }
  .anticon-eye {
    color: ${(props) => props.linkTextColor} !important;
    font-size: 16px;
    &:hover {
      color: ${(props) => props.linkTextColor} !important;
    }
  }
`;

const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
`;

const UploadFileButtonWrapper = styled(ButtonAnt)`
  border-radius: 20px;
  background: ${(props) => props.linkTextColor};
  border-color: ${(props) => props.linkTextColor};
  padding: 4px 28px;
  height: 36px;
  &:hover {
    background:${(props) => props.linkTextColor} !important;
    border-color: ${(props) => props.linkTextColor} !important;
  }
`;


const formatFileSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  const mb = bytes / (1024 * 1024);
  if (mb > 10) return `${parseFloat(mb.toFixed(2))} MB`;
  return `${mb.toFixed(1)} MB`;
};

const isPdfFile = (file) => {
  const fileName = file?.name || '';
  const mimeType = file?.type || '';
  return mimeType === 'application/pdf' || /\.pdf$/i.test(fileName);
};

const UploadFileComponent = ({uploadSuccess,setUploadSuccess, setActiveTab, setRefreshFundDocuments,clientDetails,programId }) => {
  const [fileList, setFileList] = useState([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
 

  const webuserAccessType = useSelector((state) => state.userSlice.webUserType);

  const programName = clientDetails.payload[0].programname;
  const ssnorTIN = clientDetails.payload[0].ssnortin;
  const primary_color = useSelector((state) => state.siteInfo.primaryColor);
  const secondary_color = useSelector((state) => state.siteInfo.secondaryColor);
  const rgbaPrimary = useSelector((state) => state.siteInfo.rgbaPrimary);
  const [uploadInfomessageVal, setuploadInfomessageVal] = useState(
    '0 file(s) attached (limit 10) | Current size: 0 KB (Limit: 10MB)'
  );


  // Update info message when fileList changes
  useEffect(() => {
    const count = fileList.length;
    const size = getTotalSize(fileList);

    setuploadInfomessageVal(
      `${count} file(s) attached (limit 10) | Current size: ${formatFileSize(size)} (Limit: 10MB)`
    );
    setErrorMsg('');
      // Check file count
      if (count > 10) {
        setErrorMsg('You can upload a maximum of 10 files at a time.');
      }
      // Check total size
      if (size > MAX_TOTAL_SIZE) {
             setErrorMsg('Total file size cannot exceed 10 MB.');
      }
  }, [fileList, MAX_TOTAL_SIZE]);

  // Helper to get total size in bytes
  const getTotalSize = (files) => files.reduce((sum, f) => sum + f.size, 0);

  const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
  const MAX_TOTAL_SIZE = 10 * 1024 * 1024; // 10 MB total

  const uploadProps = {
    multiple: true,
    accept: '.pdf,application/pdf',
    showUploadList: false,
    beforeUpload: (file) => {
      if (!isPdfFile(file)) {
        setErrorMsg('Only PDF files are allowed.');
        return Upload.LIST_IGNORE;
      }

      // Check individual file size
      if (file.size > MAX_FILE_SIZE) {
        setErrorMsg(`File "${file.name}" is too large. Maximum file size is 10 MB.`);
        return Upload.LIST_IGNORE;
      }

      const nextTotalSize = getTotalSize(fileList) + file.size;
      
      if (nextTotalSize > MAX_TOTAL_SIZE) {
        setErrorMsg('Total file size cannot exceed 10 MB.');
        return Upload.LIST_IGNORE;
      }

      const fileObj = file;
      setFileList((prev) => [
        ...prev,
        {
          uid: file.uid || `${Date.now()}-${file.name}`,
          name: file.name,
          size: file.size,
          status: 'done',
          originFileObj: fileObj,
        },
      ]);
      return false;
    },
  };

  const handleRemove = (uid) => {
    setFileList((prev) => prev.filter((f) => f.uid !== uid));
  };

const handleUpload = () => {
  setErrorMsg('');
  if (fileList.length === 0) return;
  if (fileList.length > 10) {
    setErrorMsg('You can upload a maximum of 10 files at a time.');
    return;
  }

  if (getTotalSize(fileList) > MAX_TOTAL_SIZE) {
    setErrorMsg('Total file size cannot exceed 10 MB.');
    return;
  }

  // Send real File objects (originFileObj) to UploadFundDocument
  const filesToSend = fileList.map(f => f.originFileObj);
  UploadFundDocument({
    ProgramId: programId,
    ProgramName: programName,
    Files: filesToSend,
    MAX_TOTAL_SIZE: MAX_TOTAL_SIZE,
  })
    .then((response) => {
      if (response.status === 200 && response.data) {
        setFileList([]);
        setUploadSuccess(true);
        setRefreshFundDocuments && setRefreshFundDocuments(r => !r);
      }
    })
    .catch((error) => {
      setErrorMsg('Upload failed.');
      console.error('Upload error:', error);
    });
};

  const handleCancel = () => {
    setFileList([]);
  };

  const handlePreview = (file) => {
    if (!file.originFileObj) return;
    const url = URL.createObjectURL(file.originFileObj);
    setPreviewUrl(url);
    setPreviewTitle(file.name);
    setPreviewVisible(true);
  };

  const handlePreviewClose = () => {
    setPreviewVisible(false);
    URL.revokeObjectURL(previewUrl);
    setPreviewUrl('');
  };

  return (
    <>
      {uploadSuccess ? (
        <Result
          status="success"
          title="Files uploaded successfully!"
          extra={[
            <UploadFileButtonWrapper type="secondary"  linkTextColor={secondary_color}  label="Fund Documents" key="fundDocs" onClick={() => { setUploadSuccess(false); setActiveTab && setActiveTab('fundDocuments'); }}>
            </UploadFileButtonWrapper>,
            <UploadFileButtonWrapper type="secondary"  linkTextColor={secondary_color} label="Upload Again" key="uploadAgain" onClick={() => setUploadSuccess(false)}>
            </UploadFileButtonWrapper>,
          ]}
        />
      ) : (
        <CardWrapper>
          <LeftPanel>
            <Title level={4} style={{ margin: 0, color: '#333' }}>
              File Upload
            </Title>
            <DropZone linkTextColor={primary_color}>
              <Dragger {...uploadProps}>
                <p className="ant-upload-drag-icon">
                  <CloudUploadOutlined />
                </p>
                <p className="ant-upload-text">Drag and Drop Files</p>
                <p className="ant-upload-hint">or</p>
                <div style={{ marginTop: 8, color: '#666', textAlign: 'center', fontSize: 13 }}>{uploadInfomessageVal}</div>
                {errorMsg && (
                  <div style={{ color: 'red', marginTop: 12, textAlign: 'center' }}>{errorMsg}</div>
                )}
                <UploadFileButtonWrapper type="secondary"  linkTextColor={secondary_color} label="Browse"/>
              </Dragger>
            </DropZone>
          </LeftPanel>
          <RightPanel>
            <Title level={4} style={{ margin: 0, color: '#333' }}>
              Uploading
            </Title>
            <FileList>
              {fileList.length === 0 && (
                <div style={{ color: '#999', marginTop: 24, textAlign: 'center' }}>
                  No files selected
                </div>
              )}
              {fileList.map((file) => (
                <FileRow key={file.uid}>
                  <FileIcon>
                    <FileOutlined />
                  </FileIcon>
                  <FileInfo>
                    <p className="file-name">{file.name}</p>
                    <p className="file-size">{formatFileSize(file.size)}</p>
                  </FileInfo>
                  <FileAction>
                    {file.status === 'done' ? (
                      <Space size={12}>
                        <EyeOutlined onClick={(e) => { e.stopPropagation(); handlePreview(file); }} />
                        <CloseOutlined onClick={() => handleRemove(file.uid)} />
                      </Space>
                    ) : (
                      <Progress
                        type="circle"
                        percent={file.percent || 0}
                        width={24}
                        strokeColor="#5b4dbe"
                      />
                    )}
                  </FileAction>
                </FileRow>
              ))}
            </FileList>
            <ActionButtons>
              {fileList.length > 0 && (
                <UploadFileButtonWrapper type="secondary"  linkTextColor={secondary_color} label="Cancel" onClick={handleCancel}/>
              )}
              <UploadFileButtonWrapper type="secondary"  linkTextColor={secondary_color} label="Upload" onClick={handleUpload} disabled={fileList.length === 0}/>
            </ActionButtons>
          </RightPanel>
        </CardWrapper>
      )}
      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={handlePreviewClose}
        width={800}
        centered
      >
        {previewUrl && (
          previewTitle.match(/\.(pdf)$/i) ? (
            <iframe
              src={previewUrl}
              style={{ width: '100%', height: '500px', border: 'none' }}
              title={previewTitle}
            />
          ) : previewTitle.match(/\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i) ? (
            <img
              alt={previewTitle}
              style={{ width: '100%' }}
              src={previewUrl}
            />
          ) : (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <FileOutlined style={{ fontSize: 48, color: '#999' }} />
              <p style={{ marginTop: 16, color: '#666' }}>
                Preview not available for this file type.
              </p>
              <a href={previewUrl} target="_blank" rel="noopener noreferrer">
                Open file
              </a>
            </div>
          )
        )}
      </Modal>
    </>
  );
};

export default UploadFileComponent;
